import { render, staticRenderFns } from "./StatisticsWellness.vue?vue&type=template&id=6eb28836&scoped=true"
import script from "./StatisticsWellness.vue?vue&type=script&lang=js"
export * from "./StatisticsWellness.vue?vue&type=script&lang=js"
import style0 from "./StatisticsWellness.vue?vue&type=style&index=0&id=6eb28836&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eb28836",
  null
  
)

export default component.exports